export default {
  DISABLE: '@WS/READ_ONLY/DISABLE',
  ENABLE: '@WS/READ_ONLY/ENABLE',
};
